<template>
    <div class="comforters-container">
        <div class="comforters">
            <div class="comforter">
                <a href="#" @click.prevent>
                    <i class="icons8-lock"/>
                    <span>Guaranteed spaces</span>
                </a>
                <div class="comforter-tooltip">
                    <div class="comforter-tooltip-content">
                        <i class="icons8-lock"/>
                        <p>A space will be available for the duration of your stay, and you can extend your parking anytime.</p>
                    </div>
                </div>
            </div>
            <div class="comforter">
                <a href="#" @click.prevent>
                    <i class="icons8-thumbs-up"/>
                    <span>Instant booking</span>
                </a>
                <div class="comforter-tooltip">
                    <div class="comforter-tooltip-content">
                        <i class="icons8-thumbs-up"/>
                        <p>Book parking within 60 seconds. Secure payments with peace of mind.</p>
                    </div>
                </div>
            </div>
            <div class="comforter">
                <a href="#" @click.prevent>
                    <i class="icons8-prize-2"/>
                    <span>Satisfaction guarantee</span>
                </a>
                <div class="comforter-tooltip">
                    <div class="comforter-tooltip-content">
                        <i class="icons8-prize-2"/>
                        <p>We know that you’ll be happy with your space. If you aren’t, a full refund will be provided.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'whitelabel-landing-comforters',
    };
</script>

<style lang="less" scoped>
    @import "~assets/less/variables";
    @import "~bootstrap/less/mixins/clearfix";
    @import "~bootstrap/less/mixins/grid";
    @import "~bootstrap/less/mixins/responsive-visibility";

    .comforters-container {
        width: 720px;
        max-width: 90%;
        margin: 42px auto 0;
        @media (max-width: @screen-sm-max) {
            .responsive-invisibility();
        }
    }

    .comforter-tooltip {
        opacity: 0;
        visibility: hidden;
        transform: translateY(10px);
        position: absolute;
        top: 100%;
        left: -30px;
        right: -30px;
        background: #ffffff;
        z-index: 2;
        box-shadow: 0 2px 13px rgba(0, 0, 0, 0.09);
        color: #394144;
        font-size: 14px;
        font-weight: 400;
        transition: 0.5s;
        margin-top: 10px;
        &:before {
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 11px 12px 11px;
            border-color: transparent transparent #ffffff transparent;
            bottom: 100%;
            left: 50%;
            margin-left: -11px;
        }
        &-content {
            display: flex;
            padding: 20px 15px;
            align-items: center;
            opacity: 0;
            transform: translateY(10px);
            transition: 0.25s;
            transition-delay: 0.1s;
        }
        i {
            color: @YPS-secondary;
            font-size: 1.8em;
            margin-right: 10px;
        }
        p {
            margin-bottom: 0;
        }
    }
    .comforters {
        .clearfix;
        .make-row;
        font-family: @headings-font-family;
        display: flex;
    }
    .comforter {
        .make-sm-column(4);
        text-align: left;
        margin-left: -6px;
        position: relative;
        color: #ffffff;
        font-size: 15px;
        font-weight: 300;
        display: flex;
        align-items: center;
        justify-content: center;
        a:focus, a:hover {
            outline: 0;
            & + .comforter-tooltip,
            & + .comforter-tooltip .comforter-tooltip-content {
                opacity: 1;
                visibility: visible;
                transform: translateY(0);
            }
        }
        span {
            position: relative;
            &:after {
                content: '';
                position: absolute;
                top: 100%;
                left: 0;
                right: 0;
                height: 1px;
                background-color: #ffffff;
                text-underline: none;
                text-decoration: none;
            }
        }
        a {
            color: #ffffff;
            text-decoration: none;
            display: flex;
            align-items: center;
            justify-content: space-around;
            opacity: 1;
            transition: 0.15s;
            &:hover {
                opacity: 0.5;
            }
            i {
                font-size: 1.8em;
                line-height: 0.7em;
                margin-right: 6px;
            }
        }
    }
</style>
